import { createTheme } from "../../../../../wsui/base";

export default createTheme({
  components: {
    MunicipioPostsModule: {
      defaultProps: {},
    },
  },
});
